import React from 'react';
import { Trans } from 'react-i18next';

import './PersonalDetailsProsBanner.scss';

export interface ProsBannerSubtitleProps {
  // Bid objective for the subcategory/location (posting_flow `max_bids`).
  bidObjective: number;
  // Availability beyond the bid goal; the extra clause is dropped when it is zero.
  extraAvailable: number;
}

// One literal per singular/plural × with/without the extra-availability clause.
const ProsBannerSubtitle = ({ bidObjective, extraAvailable }: ProsBannerSubtitleProps) => {
  const components = { bold: <span styleName="pros-banner__count-text" /> };
  const hasExtraAvailable = extraAvailable > 0;

  if (bidObjective === 1) {
    return hasExtraAvailable
      ? <Trans
          i18nKey="T.POST-JOB.PROS-BANNER.SUBTITLE-WITH-EXTRA-SINGULAR"
          defaults="<bold>1</bold> professional is ready for your job and <bold>{{extra}}</bold> more are available."
          values={{ extra: extraAvailable }}
          components={components}
        />
      : <Trans
          i18nKey="T.POST-JOB.PROS-BANNER.SUBTITLE-SINGULAR"
          defaults="<bold>1</bold> professional is ready for your job."
          components={components}
        />;
  }

  return hasExtraAvailable
    ? <Trans
        i18nKey="T.POST-JOB.PROS-BANNER.SUBTITLE-WITH-EXTRA"
        defaults="<bold>{{count}}</bold> professionals are ready for your job and <bold>{{extra}}</bold> more are available."
        values={{ count: bidObjective, extra: extraAvailable }}
        components={components}
      />
    : <Trans
        i18nKey="T.POST-JOB.PROS-BANNER.SUBTITLE"
        defaults="<bold>{{count}}</bold> professionals are ready for your job."
        values={{ count: bidObjective }}
        components={components}
      />;
};

export default ProsBannerSubtitle;
